/**
 * Fundo animado com "blobs" verdes desfocados que flutuam suavemente.
 * Fica fixo atrás de todo o conteúdo (z-index negativo) e respeita o tema.
 */
export default function AnimatedBackground() {
  return (
    <div className="bg-anim" aria-hidden="true">
      <span className="blob blob-1" />
      <span className="blob blob-2" />
      <span className="blob blob-3" />
      <span className="blob blob-4" />
      <div className="bg-grid" />
    </div>
  );
}
